import Tippy from "@tippyjs/react";
import React from "react";

const EvalLock = ({ handleClick, isLocked }) => {
    return (
        <>            
            <Tippy content={isLocked ? "Click to unlock" : "Click to lock"}>
                <div className="eval-lock" onClick={handleClick}>
                    {
                        isLocked ?

                        <svg xmlns="http://www.w3.org/2000/svg" width="25" height="25" fill="currentColor" viewBox="0 0 16 16">
                            <path d="M8 1a2 2 0 0 1 2 2v4H6V3a2 2 0 0 1 2-2m3 6V3a3 3 0 0 0-6 0v4a2 2 0 0 0-2 2v5a2 2 0 0 0 2 2h6a2 2 0 0 0 2-2V9a2 2 0 0 0-2-2"/>
                        </svg>

                        :
                        
                        <svg style={{ marginLeft: "6px" }} xmlns="http://www.w3.org/2000/svg" width="25" height="25" fill="currentColor" viewBox="0 0 16 16">
                            <path d="M11 1a2 2 0 0 0-2 2v4a2 2 0 0 1 2 2v5a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2V9a2 2 0 0 1 2-2h5V3a3 3 0 0 1 6 0v4a.5.5 0 0 1-1 0V3a2 2 0 0 0-2-2"/>
                        </svg>
                    }
                </div>
            </Tippy>
        </>
    );
}

export default EvalLock;